<ion-list>
  <ion-item *ngFor="let data of columns" lines="none" [hidden]="data.fixed">
    <ion-checkbox
      class="location-checkbox"
      (ionChange)="onStateChanged()"
      [(ngModel)]="data.display"
      name="{{ data.label }}"
      slot="start"
      [checked]="data.display"
    ></ion-checkbox>
    <ion-label class="location-label" font-regular="" text-small>
      {{ data.label }}</ion-label
    >
  </ion-item>
</ion-list>
